import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './drivers.actions.js';
import getters from './drivers.getters.js';
import mutations from './drivers.mutations.js';
import state from './drivers.state.js';

BaseStore.registerModule('drivers', {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('drivers');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
